module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"priceLines":"Pricelines","noPriceLines":"There are no pricelines yet.","chargeCode":"Code","currency":"Currency","amount":"Amount","text":"Text"},"no":{"priceLines":"Prislinjer","noPriceLines":"Det er ingen prislinjer ennå.","chargeCode":"Kode","currency":"Valuta","amount":"Beløp","text":"Tekst"}}')
  delete Component.options._Ctor
}
